<template>
  <div>
    <div>
      <div class="item">
        <span class="title">平台</span>
        <el-select
          v-model="platform_id"
          style="margin-right: 20px"
          placeholder="请选择平台"
          filterable
          :clearable="true"
          @clear="platform_id = null"
        >
          <el-option
            v-for="(item, index) in platformList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>

      <div class="item">
        <span class="title">主公众号</span>
        <el-autocomplete
          v-model="master_app.value"
          :fetch-suggestions="searchOfficial"
          placeholder="请输入主公众号"
          :clearable="true"
          @clear="(master_app.value = null),(master_app.address = null)"
          @select="item => master_app = item"
        />
      </div>

      <div class="item">
        <span class="title">副公众号</span>
        <el-button type="success" icon="el-icon-circle-plus" size="mini" @click="deputyDialog = true">添加</el-button>
      </div>
      <div v-if="officialList.length" class="item" style="flex-wrap: wrap;">
        <el-tag
          v-for="tag in officialList"
          :key="tag.address"
          size="medium"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)"
        >
          {{ tag.value }} ( {{ tag.name }} )
        </el-tag>

      </div>
      <div class="item">
        <span class="title">书籍</span>
        <el-tag v-if="bookName" class="book_tag" size="small">{{ bookName }}</el-tag>
        <el-button type="primary" size="mini" :disabled="platform_id==null" @click="choosebookid">选择书籍</el-button>
      </div>
      <div class="item">
        <span class="title">RIO系数</span>
        <el-input v-model="roi_standard" style="width: 200px;margin-right:5px" type="number" @input="$event => roi_standard = verification($event)" />
        <span>%</span>
      </div>
      <div class="item">
        <span class="title">成本</span>
        <el-input v-model="cost" style="width: 200px" type="number" @input="$event => cost = verification($event)" />
      </div>
      <div class="item">
        <span class="title">新用户ROI</span>
        <el-input v-model="roi_new_user" style="width: 200px;margin-right:5px" type="number" @input="$event => roi_new_user = verification($event)" />
        <span>%</span>
      </div>
      <div class="item">
        <span class="title">投放渠道</span>
        <el-select
          v-model="launch_channel"
          style="margin-right: 20px"
          placeholder="请选择"
          :clearable="true"
          @clear="launch_channel = null"
        >
          <el-option
            v-for="(item, index) in channelSelectList"
            :key="index"
            :label="item.channel"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="item">
        <span class="title">出号日期</span>
        <el-date-picker
          v-model="out_no_date"
          type="date"
          placeholder="选择日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
        />
      </div>
      <div class="item">
        <span class="title">绑定时间</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <div class="item">
        <span class="title">运营组</span>
        <el-autocomplete
          v-model="groupItem.value"
          :fetch-suggestions="searchGroup"
          placeholder="请输入"
          :clearable="true"
          @focus="current = '运营组'"
          @clear="(groupItem.value = null),(groupItem.address = null)"
          @select="item => groupItem = item"
        />
      </div>
      <div class="item">
        <span class="title">运营者</span>
        <el-autocomplete
          v-model="adminItem.value"
          :fetch-suggestions="searchGroup"
          placeholder="请输入"
          :clearable="true"
          @focus="current = '运营者'"
          @clear="(adminItem.value = null),(adminItem.address = null)"
          @select="item => adminItem = item"
        />
      </div>
      <div class="item">
        <span class="title">投手组</span>
        <el-autocomplete
          v-model="launchItem.value"
          :fetch-suggestions="searchSdLaunch"
          placeholder="请输入"
          :clearable="true"
          @focus="current = '投手组'"
          @clear="(launchItem.value = null),(launchItem.address = null)"
          @select="item => launchItem = item"
        />
      </div>
      <div class="item">
        <span class="title">投手</span>
        <el-autocomplete
          v-model="pitcherItem.value"
          :fetch-suggestions="searchSdLaunch"
          placeholder="请输入"
          :clearable="true"
          @focus="current = '投手'"
          @clear="(pitcherItem.value = null),(pitcherItem.address = null)"
          @select="item => pitcherItem = item"
        />
      </div>
    </div>
    <div style="text-align: end; margin-top:20px">
      <el-button class="" type="primary" @click="determine">确定</el-button>
    </div>
    <el-dialog
      title="添加副公众号"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="deputyDialog"
      :destroy-on-close="true"
      width="20%"
      @closed="deputy_app = {}, deputyPlatform = {}"
    >
      <div v-if="deputyDialog">
        <div class="item">
          <span class="title">平台</span>
          <el-select
            v-model="deputyPlatform.id"
            style="margin-right: 20px"
            placeholder="请选择平台"
            filterable
            :clearable="true"
            @change="handleDeputy"
            @clear="deputyPlatform.id = null"
          >
            <el-option
              v-for="(item, index) in platformList"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>

        <div class="item">
          <span class="title">副公众号</span>
          <el-autocomplete
            v-model="deputy_app.value"
            :fetch-suggestions="searchOfficial"
            placeholder="请输入副公众号"
            :clearable="true"
            @clear="(deputy_app.value = null),(deputy_app.address = null)"
            @select="item => deputy_app = item"
          />
        </div>
        <el-button type="success" @click="handleSelect">添加</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="选择书籍"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="booksDialog"
      :destroy-on-close="true"
      width="50%"
    >
      <bookdialog v-if="booksDialog" ref="chooseviewr" @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
import { getOfficialAccount, getPlatform, groupList, adminList, getsdLaunchList, getIndexLauncher, getChannelList } from '@/api/platformLabel.js'
import bookdialog from '@/views/extensionlink/components/bookdialog.vue'
export default {
  components: { bookdialog },
  props: {
    drawerItem: {
      type: Object,
      default() {
        return {
        }
      }
    }
  },
  data() {
    return {
      master_app: { value: null, address: null }, // 主公众号item
      groupItem: { value: null, address: null }, // 运营组item
      adminItem: { value: null, address: null }, // 运营者item
      launchItem: { value: null, address: null }, // 投手组item
      pitcherItem: { value: null, address: null }, // 投手者item
      launch_channel: null, // 投放渠道
      bookName: null, // 书籍
      bookId: null, // 书籍ID
      out_no_date: null, // 出号日期
      deputy_app: { value: null, address: null }, // 副公众号
      deputyDialog: false,
      booksDialog: false,
      platform_id: null, // 平台id
      deputyPlatform: { name: null, id: null }, // 副公众号平台
      platformList: null, // 平台列表
      channelSelectList: null, // 渠道列表
      roi_standard: null, // RIO标准
      cost: null, // 成本
      roi_new_user: null, // 新用户ROI
      officialList: [], // 渲染副公众号tag列表的数组
      loading: false,
      current: null,
      date: [] // 绑定时间
    }
  },
  created() {
    window.aaa = this
    this.myGetchannelplatform() // 获取平台
    this.getChannelList() // 渠道列表
    this.drawerItem && this.drawerItem.id && this.init()
  },
  mounted() {
  },
  methods: {
    // 选中的副公众号和平台添加到tag列表数组
    handleSelect() {
      if (this.deputy_app.address === this.master_app.address) {
        this.$message({
          message: '主公众号与副公众号不能重复',
          type: 'warning'
        })
        return
      }
      for (let i = 0; i < this.officialList.length; i++) {
        if (this.officialList[i].address === this.deputy_app.address) {
          this.$message({
            message: '公众号已被选中',
            type: 'warning'
          })
          return
        }
      }
      if (!this.deputy_app.value || !this.deputy_app.address) {
        this.$message({
          message: '请从列表选择副公众号',
          type: 'warning'
        })
        return
      }
      this.officialList.push({ value: this.deputy_app.value, address: this.deputy_app.address, id: this.deputyPlatform.id, name: this.deputyPlatform.name })
      // console.log(this.officialList)
      this.deputy_app = {}
      this.deputyPlatform = {}
      this.deputyDialog = false
    },
    // 选中的副公众号-平台item
    handleDeputy() {
      const obj = this.platformList.find(item => {
        return item.id === this.deputyPlatform.id
      })
      this.deputyPlatform.name = obj.name
    },
    // 删除副公众号tag
    handleClose(tag) {
      this.officialList = this.officialList.filter(itme => {
        return tag.address !== itme.address
      })
      // console.log(this.officialList)
    },
    // 选择书籍按钮
    choosebookid() {
      this.booksDialog = true
      this.$nextTick(() => {
        this.$refs.chooseviewr.send(this.platform_id)
      })
    },
    // 选中的书籍item
    callback(val) {
      // console.log('val', val)
      this.bookName = val.book_title
      this.bookId = val.id
      this.booksDialog = false
    },
    // 搜索
    async searchOfficial(queryString, cb) {
      const data = await getOfficialAccount({
        accountName: queryString || null
      })
      cb(data.data.list.map((item) => {
        return {
          value: item.account_name,
          address: item.app_id
        }
      }))
    },
    // 搜索
    async searchGroup(queryString, cb) {
      const currentFunc = this.current === '运营者' ? adminList : groupList
      if (!currentFunc) {
        return
      }
      if (this.current === '运营者' && !this.groupItem.address) {
        this.$message({
          message: '请先选择运营组，才能选择运营者',
          type: 'warning'
        })
        cb()
        return
      }
      this.adminItem = this.current === '运营组' ? { address: null, value: null } : this.adminItem
      const data = await currentFunc({
        group_id: this.current === '运营者' ? this.groupItem.address : null
      })
      cb(data.data.map(item => {
        return {
          value: this.current === '运营者' ? item.realName : item.title,
          address: item.id + ''
        }
      }))
    },
    // 搜索投手和投手组
    async searchSdLaunch(queryString, cb) {
      const currentFunc = this.current === '投手组' ? getsdLaunchList : getIndexLauncher
      if (!currentFunc) {
        return
      }
      if (this.current === '投手' && !this.launchItem.address) {
        this.$message({
          message: '请先选择投手组，才能选择投手',
          type: 'warning'
        })
        cb()
        return
      }
      this.pitcherItem = this.current === '投手组' ? { address: null, value: null } : this.pitcherItem
      const data = await currentFunc({
        page: 1,
        page_size: 10,
        keywords: this.current === '投手组' ? queryString : null,
        group_id: this.current === '投手' ? this.launchItem.address : null
      })
      cb(data.data.list.map(item => {
        return {
          value: item.name,
          address: item.id + ''
        }
      }))
    },
    // 请求平台列表数据
    async myGetchannelplatform() {
      const data = await getPlatform({ type: 1 })
      this.platformList = data.data.list
    },
    // 投放渠道列表
    async getChannelList() {
      const data = await getChannelList()
      this.channelSelectList = data.data
    },
    // 确定
    determine() {
      if (this.judgmentParameters()) {
        const parameter = this.assemblyParameters()
        this.$emit('determine', parameter)
      }
    },

    // 判断参数
    judgmentParameters() {
      // console.log(this.groupItem)
      let text = null
      if (!this.platform_id) {
        text = '请选择主公众号平台'
      } else if (!this.master_app || !this.master_app.address) {
        text = '请填写主公众号'
      } else if (!this.groupItem || !this.groupItem.address) {
        text = '请选择运营组'
      } else if (!this.adminItem || !this.adminItem.address) {
        text = '请选择运营者'
      } else if (!this.launchItem || !this.launchItem.address) {
        text = '请选择投手组'
      } else if (!this.pitcherItem || !this.pitcherItem.address) {
        text = '请选择投手'
      } else if (!this.date || !this.date.length) {
        text = '请选择日期'
      } else if (!this.roi_standard) {
        text = '请设置RIO标准'
      } else if (!this.out_no_date) {
        text = '请设置出号日期'
      } else if (!this.launch_channel) {
        text = '请填写投放渠道'
      } else if (!this.bookId || !this.bookName) {
        text = '请选择书籍'
      }
      text && this.$message({
        message: text,
        type: 'warning'
      })

      return !text
    },
    // 处理ROI输入框
    verification(value) {
      const text = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
      return text
    },
    // 组装参数
    assemblyParameters() {
      const vice_app_ids = this.officialList.map(i => i.address)
      const vice_platform_ids = this.officialList.map(i => i.id)
      const obj = {
        s_date: this.date[0],
        e_date: this.date[1],
        master_app_id: this.master_app.address,
        master_platform_id: this.platform_id,
        novel_id: this.bookId,
        roi_standard: this.roi_standard,
        out_no_date: this.out_no_date,
        launch_channel: this.launch_channel,
        operate_group_id: this.groupItem.address,
        operate_admin_id: this.adminItem.address,
        vice_platform_ids,
        vice_app_ids,
        cost: this.cost,
        roi_new_user: this.roi_new_user,
        launch_group_id: this.launchItem.address,
        launch_id: this.pitcherItem.address
      }
      return obj
    },

    // 初始化
    init() {
      // 副公众号tag渲染列表
      let obj = []
      obj = this.drawerItem.app_ids.map(item => {
        return {
          address: item
        }
      })
      this.drawerItem.account_names.forEach((item, index) => {
        obj[index].value = item
      })
      this.drawerItem.platform_ids.forEach((item, index) => {
        obj[index].id = item
      })
      this.drawerItem.platform_names.forEach((item, index) => {
        obj[index].name = item
      })

      obj = obj.filter(i => i.address !== this.drawerItem.master_app_id)
      // console.log(obj)
      this.officialList = obj

      // 绑定时间
      this.date = [this.drawerItem.s_date_str, this.drawerItem.e_date_str]

      // 主公众号
      this.master_app.value = this.drawerItem.account_names[0]
      this.master_app.address = this.drawerItem.master_app_id

      // 书籍
      this.bookName = this.drawerItem.novel_title
      this.bookId = this.drawerItem.novel_id

      // ROI标准
      this.roi_standard = this.drawerItem.roi_standard

      // 平台
      this.platform_id = this.drawerItem.platform_ids[0]

      // 投放渠道
      this.launch_channel = Number(this.drawerItem.launch_channel)

      // 成本
      this.cost = this.drawerItem.cost

      // 新用户ROI
      this.roi_new_user = this.drawerItem.roi_new_user

      // 出号日期
      this.out_no_date = this.drawerItem.out_no_date_str

      // 运营组
      this.groupItem.value = this.drawerItem.group_str
      this.groupItem.address = this.drawerItem.operate_group_id + ''
      // 运营者
      this.adminItem.value = this.drawerItem.admin_str
      this.adminItem.address = this.drawerItem.operate_admin_id + ''

      // 投手组
      this.launchItem.value = this.drawerItem.launch_group_str
      this.launchItem.address = this.drawerItem.launch_group_id + ''

      // 投手
      this.pitcherItem.value = this.drawerItem.launch_str
      this.pitcherItem.address = this.drawerItem.launch_id + ''
    }
  }
}
</script>

<style scoped>
.item{
   display: flex;
   align-items: center;
   margin-bottom: 20px;
}

.item .title{
    display: inline-block;
    width: 80px;
}

.checkBox{
   margin-bottom: 26px;
}

.el-tag--medium {
  margin: 10px 10px 0 0 !important;
  height: 35px !important;
  line-height: 35px !important;
  font-size: 14px !important;

}

.tag_input{
  width: 150px;
}
.book_tag{
  margin-right:10px;
  height: 30px;
  line-height: 30px;
}
</style>
